import { useQuery } from '@tanstack/react-query';

import { GlobalReactQueryOptions } from '../../config';
import { fetchOrders, FetchOrdersResponse } from '../../api/orders/fetchOrders';
import { UseQueryResult } from '../../api/query-types';

type UseOrderListsQuery = UseQueryResult<'data', FetchOrdersResponse>;

type UseOrderListsQueryOptions = {
    readonly page: number;
    readonly pageSize: number;
    readonly sortBy: string;
    readonly fetchFunc?: typeof fetchOrders;
};

const emptyOrderData = { totalCount: 0, orders: [] };

export const useOrderListsQuery = ({
    page,
    pageSize,
    sortBy,
    fetchFunc = fetchOrders
}: UseOrderListsQueryOptions): UseOrderListsQuery => {
    const params = { page, pageSize, sortBy };
    const { data, ...result } = useQuery(['ordersList', params], () => fetchFunc(params), {
        ...GlobalReactQueryOptions,
        keepPreviousData: true
    });

    return {
        ...result,
        data: data ?? emptyOrderData
    };
};
